import { render, staticRenderFns } from "./ModalLinkTrigger.vue?vue&type=template&id=4720d638&"
import script from "./ModalLinkTrigger.vue?vue&type=script&lang=js&"
export * from "./ModalLinkTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports